module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Ignition")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Two boys walked down the beach, deep in conversation. Seventeen-year-old Jeff Luty was carrying a carbon-fiber pipe rocket. His best friend, Carlos Tucay, was carrying the launch rod and a cheap bottle of Mieux champagne. Gangly Jeff was a head taller than Carlos.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re unobservable now,” said Jeff, looking back down the sand. It was twilight on a clear New Year’s Day in Stinson Beach, California. Jeff’s mother had rented a cheap cottage in order to get out of their cramped South San Francisco apartment for the holiday, and Carlos had come along. Jeff’s mother didn’t like it when the boys fired off their homemade rockets; so Jeff had promised her that he and Carlos wouldn’t bring one. But of course they had.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Our flying beetle,” said Carlos with his ready grin. “Your program says it’ll go "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("how")]), _vm._v(" high? Tell me again, Jeff. I love hearing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A mile,” said Jeff, hefting the heavy gadget. “Equals one thousand, six hundred and nine-point-three-four-four meters. That’s why we measured out the fuel in milligrams.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As if this beast is gonna act like your computer simulation,” laughed Carlos, patting the thick rocket’s side. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Yeek!”")]), _vm._v(" The rocket’s tip was a streamlined plastic cone with a few thousand homegrown nanochips inside. The rocket’s sides were adorned with fanciful sheet metal fins and a narrow metal pipe that served as a launch lug. Carlos had painted the rocket to resemble an iridescent blue-green beetle with toothy jaws and folded spiky legs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re lucky we didn’t blow up your mom’s house when we were casting the motor,” said Jeff. “A kilogram of ammonium nitrate fertilizer and powdered magnesium metal mixed into epoxy binder, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("whoa.")]), _vm._v("” He hefted the rocket, peering up the beetle’s butt at the glittering, rubbery fuel. The carbon-fiber tube was stuffed like a sausage casing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here’s to Lu-Tuc Space Tech!” said Carlos, peeling the foil off the champagne cork. He’d liberated one of the bottles that Jeff’s mother was using to make mimosas for herself and her boyfriend and Jeff’s older sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lu-Tuc forever,” echoed Jeff. The boys dreamed of starting a company some day. “It’ll be awesome to track our nanochips across the sky,” Jeff continued. “Each one of them has a global positioning unit and a broadcast antenna.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They do so much,” marveled Carlos.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And I grew them like yeast,” said Jeff. “In the right environment these cute little guys can self-assemble. If you know the dark secrets of robobiohackery, that is. And if you have the knack.” He waggled his long, knobby fingers. His nails were bitten to the quick.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re totally sure they’re not gonna start reproducing themselves in the air?” said Carlos, working his thumbs against the champagne cork. “We don’t want Lu-Tuc turning the world into rainbow goo.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That won’t happen yet,” said Jeff and giggled. “Dammit.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re sick,” said Carlos, meaning this as praise. The cork popped loose, arcing high across the beach to meet its racing shadow.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was Carlos’s turn to giggle as the foam gushed over his hands. He took a swig and offered the bottle to Jeff. Jeff waved him off, intent on his future dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see an astronomically large cloud of self-reproducing nanobots in orbit around the sun,” said Jeff. “They’ll feed on space dust and solar energy and carry out calculations too vast for earthbound machines.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that’s")]), _vm._v(" what self-reproducing nanomachines are good for,” said Carlos.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m gonna call them "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nants,")]), _vm._v("” said Jeff. “You like that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Beautiful,” said Carlos, jamming the launch rod into the sand a few meters above the waterline. “I claim this kingdom for the nants.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jeff slid the rocket down over the launch rod, threading the rod through the five-inch metal tube glued to the rocket’s side. He stuck an igniter wire into the molded engine, secured the wire with wadding, and attached the wire’s loose ends to the ignition unit: a little box with an antenna.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The National Association of Rocketry says we should back off seven hundred feet now,” said Jeff, checking over their handiwork one last time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bogus,” said Carlos. “I want to watch our big beetle go throbbing into the air. We’ll get behind that dune here and peek.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Affirmative,” said Jeff.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boys settled onto the lee slope of a low dune and inched up until they could peer over the crest at the gaudy fat tube. Carlos dug a little hole in the sand to steady the champagne bottle. Jeff took out his cell phone. The launch program was idling on the screen, cycling through a series of clock and map displays.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can really see the jetliners on that blue map?” asked Carlos, his handsome face gilded by the setting sun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You bet. Good thing, too. We’ll squirt up our rocket when there’s a gap in the traffic. Like a bum scuttling across a freeway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s the cluster of red dots on that next map?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Those are the nanochips in the rocket’s tip. At apogee, the nose cone blows off and the dots scatter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Awesome,” said Carlos. “The beetle shoots his wad. Maybe we should track down some of those nanochips after they land.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We go visit some guy in the Sunset district, and we’re, like, congratulations, a Lu-Tuc nant is idling in your driveway!” said Jeff, his homely face wreathed in smiles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Gosh, Mr. Luty, can I drive it to work?” riffed Carlos, sounding like an earnest wage earner. “You got a key?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here comes a gap in the planes,” said Jeff.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go,” answered Carlos, his face calm and dreamy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“T minus one hundred twenty seconds,” said Jeff, punching in a control code. In two minutes the phone would signal the ignition unit.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only now, damn, here came a ponytailed woman jogging along the beach with a dog. And of course she had to stop by the rocket and spot the boys. Jeff paused the countdown.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What are you doing?” asked the woman, her voice like a dentist’s drill. “Do you have permission for this?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s just a little toy rocket kit I got for Christmas,” called Carlos. “Totally legit, ma’am. No problem. Happy New Year.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well—you two be careful,” said the woman. “Don’t set off that thing while I’m around. Hey, come here, Guster!” Her dog had lifted his leg to squirt pee onto the rocket’s side. Embarrassed now, the woman jogged off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Bounce, bounce, bounce,” said Carlos loud enough for her to hear, and then switched to an officious tone. “I recommend that you secure the integrity of the launch vehicle, Mr. Luty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not wiping off dog piss! I can smell it from here. See it dripping down? We’ll cleanse the planet and send it into the sky.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Resume countdown, Mr. Luty.” Carlos took another pull from the champagne bottle. “This tickles my nose.” He threw back his head and gave a sudden cracked whoop. “Happy New Year! Hey, maybe I should piss on the rocket too!” He handed Jeff the bottle, and made as if to stand up, but Jeff threw his arm over his friend.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Batten down for Lu-Tuc Space Tech!” said Jeff, enjoying Carlos’s closeness. He looked up and down the long empty beach. The woman was a small dab in the distance. And now she deviated into a side path. “T minus sixty seconds,” said Jeff, snugging the bottle into its hole. “Battle stations, Carlos.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The boys backed down below the crest and lay side by side staring at Jeff’s little screen. The last ten seconds ticked off. And nothing happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Shit,” said Carlos, raising his head to peer over the dune’s crest. “Do you think the dog—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The blast was something Jeff felt more than heard. A hideous pressure on his ears. Shrapnel whizzed overhead; he could feel the violent rippling of the air. Carlos was lying face down, very still. Blood stained the sand, outlining Carlos’s head. For a second Jeff could think he was only seeing a shadow. But no.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not sure if he should roll his friend over, Jeff looked distractedly at the screen of his cell phone. How strange. The chaotic explosion must have sent a jet of nanomachines into Carlos’s face, for Jeff could see a ghostly form of his friend’s features on the little screen, a stippling of red dots. Carlos looked all right except for his—eye?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jeff could hear sirens, still very far. Carlos didn’t seem to be breathing. Jeff went ahead and rolled Carlos over so he could give him mouth-to-mouth resuscitation. Maybe the shock wave had knocked his breath out. Maybe that was all. Maybe everything was still retrievable. But no, the five-inch metal tube that served as launch lug had speared through Carlos’s right eye. Stuff was oozing from the barely protruding tip. Carlos had definitely stopped breathing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jeff leaned over his beloved friend, pressing his mouth to Carlos’s blood-foamed lips, trying to breathe in life. He was still at it when his mother and sisters found him. The medics had to sedate him to make him stop.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63482542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781466804876_ch01.vue
// module id = 72
// module chunks = 0